export function toBlogPostResourceIcon(type: string | undefined) {
  if (type === "Présentation") return "ph:lectern";
}
